import React from 'react';
import PropTypes from 'prop-types';

const cellStyle = {
  maxWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const TagCell = ({ tagNames }) => {
  const combined = (tagNames || [])
    .slice()
    .sort((a, b) => a.localeCompare(b))
    .join(', ');
  return (
    <td className="align-middle" style={cellStyle} title={combined}>
      {combined || '—'}
    </td>
  );
};

TagCell.propTypes = { tagNames: PropTypes.arrayOf(PropTypes.string) };
TagCell.defaultProps = { tagNames: [] };

export default TagCell;
